<script>
    import { createEventDispatcher } from "svelte";
    import SlideshowItem from "../../common/SlideshowItem.svelte";
    import { _ } from "svelte-i18n";

    export let event;
    export let flipped;

    const dispatch = createEventDispatcher();
</script>

<SlideshowItem
    {flipped}
    on:click={() => dispatch("click")}
    titleImage={event.titleImage}
>
    <div slot="content">
        <div class="text-l type">{$_("recent")}</div>
        <div class="headline-s slogan">{event.title}</div>
        <div class="text-l slogan">{event.subtitle}</div>
    </div>
</SlideshowItem>

<style>
    .type {
        font-size: 16px;
        text-transform: none;
    }

    .slogan {
        margin-top: 4px;
    }
</style>
